<template>
  <div class="h-full flex-grow overflow-y-auto">
    <InformationContainer
      v-if="clientCosts && clientCosts.length"
      :client-costs="clientCosts"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InformationContainer from 'dashboard/routes/dashboard/settings/subscription/information/InformationContainer.vue';
import WhatsAppAPI from 'dashboard/api/whatsApp';

export default {
  components: { InformationContainer },

  data() {
    return {
      clientCosts: [],
    };
  },

  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
  },

  mounted() {
    this.fetchWhatsAppCostsWithDetails();
  },

  methods: {
    async fetchWhatsAppCostsWithDetails() {
      // Calculate previous month boundaries in UTC to avoid local tz offsets
      const now = new Date();
      const prevMonthUtcYear = now.getUTCFullYear();
      const prevMonthUtcMonth = now.getUTCMonth() - 1;
      const startDate = Math.floor(
        Date.UTC(prevMonthUtcYear, prevMonthUtcMonth, 1) / 1000
      );
      const endDate = Math.floor(
        Date.UTC(prevMonthUtcYear, prevMonthUtcMonth + 1, 0, 23, 59, 59, 999) /
          1000
      );

      try {
        const payload = {
          accountId: this.accountId,
          startDate: null,
          endDate: null,
        };

        const { data: currentData } =
          await WhatsAppAPI.getWhatsAppCostsWithDetails(payload);

        const { data: lastData } =
          await WhatsAppAPI.getWhatsAppCostsWithDetails({
            ...payload,
            startDate,
            endDate,
          });

        if (!currentData && !lastData) {
          throw new Error();
        }

        const formattedCosts = [];

        if (currentData && currentData.message_statistics) {
          const formattedCurrentData = this.formatCosts(
            currentData.message_statistics,
            currentData.currency
          );

          formattedCosts.push({
            title: this.$t(
              'CHATLYN_SUBSCRIPTION.INFORMATION.ESTIMATED_INFORMATION.TITLE'
            ),
            total: currentData.message_statistics.total?.costs || '€ 0.00',
            items: this.transformToArray(formattedCurrentData),
          });
        }

        if (lastData && lastData.message_statistics) {
          const formattedLastData = this.formatCosts(
            lastData.message_statistics,
            lastData.currency
          );

          formattedCosts.push({
            title: this.$t(
              'CHATLYN_SUBSCRIPTION.INFORMATION.LAST_MONTH_INFORMATION.TITLE'
            ),
            total: lastData.message_statistics.total?.costs || '€ 0.00',
            items: this.transformToArray(formattedLastData),
          });
        }

        this.clientCosts = formattedCosts;
      } catch (error) {
        this.clientCosts = [];
      }
    },

    formatCosts(statistics, currency = 'eur') {
      const currencySymbol = this.getCurrencySymbol(currency);
      const formattedStats = { ...statistics };

      Object.keys(formattedStats).forEach((key) => {
        if (
          formattedStats[key] &&
          typeof formattedStats[key].costs === 'number'
        ) {
          formattedStats[key].costs = `${currencySymbol} ${formattedStats[
            key
          ].costs.toFixed(2)}`;
        }
      });

      return formattedStats;
    },

    getCurrencySymbol(currency) {
      const currencyMap = {
        eur: '€',
        usd: '$',
      };

      return currencyMap[currency] || currency;
    },

    transformToArray(statisticsObj) {
      if (!statisticsObj) return [];

      return Object.entries(statisticsObj)
        .filter(([key]) => key !== 'total')
        .map(([key, value]) => ({
          name: key,
          quantity: Number(value.paid_quantity).toLocaleString('en'),
          costs: value.costs,
        }));
    },
  },
};
</script>

<style></style>
